import {  GenericParamFields, ParamFormRow } from "entity/Indicador/components/ParamFields"

import LC from ".."

import TextInput from "components/form/input/TextInput"

export function LCParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields
            name={LC.field + tipoIndicadorField}
            bottomFields={
                <>                   
                    <ParamFormRow label="Metro por Ponto Avaliado">
                        <TextInput name="manual.metroPontoAvaliado" label="Valor (Metros)" type="number" />
                    </ParamFormRow>                  
                    <ParamFormRow label="Meta Max. Adultas (QT/Metro Avaliado)">
                        <TextInput name="manual.metaMaxAdultas" label="Quantidade" type="number" />
                    </ParamFormRow>

                    <ParamFormRow label="Meta Max. Ninfas (QT/Metro Avaliado)">
                        <TextInput name="manual.meta" label="Meta (Ninfas/Metro)" type="number" />
                    </ParamFormRow>
                </>
            }
        />
    )
}
